"use strict";

import helpers from "./_helpers";

const Tabs = () => {
    const init = () => {
        $(function() {
            var old_is_mobile = helpers.isMobile();

            initAll();
            initUpdateHeightForExtras();

            $(window).on('resize',
                helpers.debounce(function(){
                    // Check if it has Changed from mob to desk or vice versa
                    var new_is_mobile = helpers.isMobile();

                    if(old_is_mobile !== new_is_mobile) {
                        initAll();
                    }
                    old_is_mobile = new_is_mobile;

                    initUpdateHeightForExtras();
                })
            );

            function initAll() {
                var $tabsLeftContainers = $('.js-tabs-left');
                if ($tabsLeftContainers.length > 0) {
                    initTabLeftAccordions($tabsLeftContainers);
                }

                var $tabsContainers = $('.js-tabs');
                if ($tabsContainers.length > 0) {
                    initTabAccordions($tabsContainers);
                }
            }

            function initUpdateHeightForExtras() {
                var $tabsLeftContainers = $('.js-tabs-left');
                if ($tabsLeftContainers.length > 0) {
                    updateHeightForExtras($tabsLeftContainers);
                }

                var $tabsContainers = $('.js-tabs');
                if ($tabsContainers.length > 0) {
                    updateHeightForExtras($tabsContainers);
                }
            }

            function updateHeightForExtras($tabsContainers) {
                $tabsContainers.each(function() {
                    var $tabsContainer = $(this);

                    var $pages = $tabsContainer.find('.js-tabs-page');
                    var $pages_extra = $tabsContainer.find('.js-tabs-page-show-extra');

                    if($pages_extra.length > 0) {
                        $pages.each(function() {
                            var $extra_page = $pages_extra.filter('[data-id="'+$(this).data('id')+'"]');
                            if($extra_page.length) {
                                $(this).css('top', $extra_page.outerHeight());
                            }
                        });
                    }
                });
            }

            function initTabAccordions($tabsContainers) {
                $tabsContainers.each(function() {
                    var $tabsContainer = $(this);

                    var $tabs = $tabsContainer.find('.js-tabs-tab');
                    var $pages = $tabsContainer.find('.js-tabs-page');
                    var $pages_extra = $tabsContainer.find('.js-tabs-page-show-extra');
                    var $mobile_tabs = $tabsContainer.find('.js-tabs-tab-mobile');

                    $tabs.on('click', function(){
                        var $tab = $(this);
                        showTab($tabsContainer, $pages, $tab, $pages_extra);
                    });

                    // Initial load
                    if(helpers.isMobile()) {
                        // accordions on mobile
                        $mobile_tabs.off('click');
                        $mobile_tabs.on('click', function (e) {
                            var target_tab = $(this).next();

                            if ($(this).hasAttr('data-tab-extra-parent')) {
                                target_tab = $(this).parent().next();
                            }

                            if ($(this).hasClass('open')) {
                                $(this).removeClass('open').parent().removeClass('child-open');
                                target_tab.removeClass('open').stop().slideUp();
                                return;
                            }

                            $(this).parent().parent().find('.js-tabs-tab-mobile').removeClass('open');
                            target_tab.removeClass('open').slideUp();

                            e.preventDefault();
                            $(this).addClass('open').parent().addClass('child-open');
                            target_tab.addClass('open').stop().slideDown(function() {
                                $('html, body').animate({
                                    scrollTop: $(this).offset().top - 120
                                }, 100);
                            });
                        });
                    }else{
                        // tabs on desktop
                        var $tab_headers = $tabsContainer.find('.js-tabs-tab');
                        $tabs.filter(':first-child').each(function(){
                            var $tab = $(this);
                            var $tab_header = $tab_headers.filter('[data-id="'+$tab.data('id')+'"]');
                            if(!$tab_header.hasClass('js-tabs-tab')){
                                $tab.trigger('click');
                            }
                        })
                        $tabs.filter(':first-child').trigger('click');
                    }
                });
            }

            function initTabLeftAccordions($tabsContainers) {
                $tabsContainers.each(function() {
                    var $tabsContainer = $(this);
                    var $tabs = $tabsContainer.find('.js-tabs-left-tab');
                    var $pages = $tabsContainer.find('.js-tabs-left-page');
                    var $pages_extra = $tabsContainer.find('.js-tabs-left-page-show-extra');

                    $tabs.on('click', function(){
                        var $tab = $(this);
                        showTab($tabsContainer, $pages, $tab, $pages_extra);
                    });

                    // Initial load
                    if(helpers.isMobile()) {
                        // accordions on mobile
                        $tabs.off('click');
                        $tabs.on('click', function (e) {
                            var $tab_to_show = $pages.filter('[data-id="'+$(this).data('id')+'"]');

                            if ($(this).hasClass('open')) {
                                $(this).removeClass('open');

                                $tab_to_show.removeClass('open').stop().slideUp();
                                return;
                            }

                            $tabs.removeClass('open');
                            $pages.removeClass('open').slideUp();

                            e.preventDefault();
                            $(this).addClass('open');
                            $tab_to_show.addClass('open').stop().slideDown();
                        });
                    }else{
                        // tabs on desktop
                        var $tab_headers = $tabsContainer.find('.js-tabs-left-tab');
                        $tabs.filter(':first-child').each(function(){
                            var $tab = $(this);
                            var $tab_header = $tab_headers.filter('[data-id="'+$tab.data('id')+'"]');
                            if(!$tab_header.hasClass('js-tabs-left-tab')){
                                $tab.trigger('click');
                            }
                        })
                        $tabs.filter(':first-child').trigger('click');
                    }
                });
            }

            function showTab($tabsContainer, $pages, $tab, $pages_extra) {
                $tab.siblings('.js-tabs-tab, .js-tabs-left-tab').removeClass('open');
                $tab.addClass('open');
                $pages.removeClass('open');
                $pages_extra.removeClass('open');


                var $page = $pages.filter('[data-id="'+$tab.data('id')+'"]');
                $page.addClass('open');
                var $extra_page = $pages_extra.filter('[data-id="'+$tab.data('id')+'"]');
                $extra_page.addClass('open');

                if(!helpers.isMobile()) {
                    setTimeout(() => {
                        var new_height = $page.outerHeight();
                        if($extra_page.length) {
                            new_height = new_height + $extra_page.outerHeight();
                        }
                        var left_col = $tabsContainer.find('.js-tabs-left-col');
    
                        if(left_col.length > 0) {
                            if(new_height < left_col.height()) {
                                new_height = left_col.height();
                            }
                        }
    
                        if(new_height != 0) {
                            $page.parents('.js-tabbed-pages-container').height(new_height);
                        }
                    }, 500)
                }
            }
        });
    };

    return {
        init:init
    };
};

export default Tabs;